import { cloneElement } from "react";
import { Tooltip } from "@mui/material";
import InfoIcon from "../components/icons/InfoIcon";
import { Box } from "@mui/system";

export default function FieldWrapper({ children, data }) {
  const { field_name: fieldName = "", description } = data;
  // create a unique ID for the description identifier
  const descriptionId = `${fieldName}-description`;

  // Only show tooltip if there's a description
  if (!description) {
    return (
      <Box sx={{ "& > .MuiFormControl-root ": { width: "100%" } }}>
        {children}
      </Box>
    );
  }

  // Clone the children to add aria-describedby
  const enhancedChildren = cloneElement(children, {
    "aria-describedby": `${
      children.props["aria-describedby"] || ""
    } ${descriptionId}`.trim(),
  });

  return (
    <Box
      sx={{
        position: "relative",
        "& > .MuiFormControl-root ": {
          width: "100%",
        },
      }}
    >
      {/* Hidden description for screen readers */}
      <Box
        id={descriptionId}
        sx={{
          position: "absolute",
          width: "1px",
          height: "1px",
          padding: 0,
          margin: "-1px",
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        {description}
      </Box>
      {enhancedChildren}
      <Tooltip
        title={description}
        arrow
        placement='top'
        enterDelay={200}
        leaveDelay={200}
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: "0.875rem", // Adjust this value as needed
              maxWidth: 300,
              lineHeight: 1.5,
            },
          },
        }}
      >
        <Box
          data-testid='info-tooltip-trigger'
          component='span'
          sx={{
            position: "absolute",
            right: "-20px",
            top: "-10px",
            cursor: "help",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <InfoIcon />
        </Box>
      </Tooltip>
    </Box>
  );
}
